@if(!msgFeedback){
<app-banner></app-banner>
}

<!-- Ultra Modern Layout -->
<div class="ultra-modern-wrapper">
  <div class="ultra-modern-container">
    @if(!msgFeedback){
    
    <!-- Hero Section com Stepper -->
    <div class="hero-section">
      <div class="hero-content">
        <h1 class="hero-title">Solicitação de Análise Técnica</h1>
        <p class="hero-subtitle">Preencha os dados abaixo para registrar sua solicitação SAC</p>
      </div>
      
      <!-- Stepper Moderno -->
      <div class="modern-stepper">
        <div class="stepper-line"></div>
        <div class="step-item active completed">
          <div class="step-circle">
            <span class="material-icons">person</span>
          </div>
          <span class="step-label">Cliente</span>
        </div>
        <div class="step-item" [class.active]="pwForm?.get('customer')?.valid" [class.completed]="pwForm?.get('vehicle')?.valid">
          <div class="step-circle">
            <span class="material-icons">directions_car</span>
          </div>
          <span class="step-label">Veículo</span>
        </div>
        <div class="step-item" [class.active]="pwForm?.get('vehicle')?.valid">
          <div class="step-circle">
            <span class="material-icons">tire_repair</span>
          </div>
          <span class="step-label">Pneus</span>
        </div>
      </div>
    </div>

    <form *ngIf="pwForm" [formGroup]="pwForm" class="ultra-modern-form">

      <!-- Card Cliente -->
      <div class="ultra-card-alt animate-in">
        <div class="card-number">01</div>
        <div class="card-header-alt">
          <div class="header-icon-alt">
            <span class="material-icons">account_circle</span>
          </div>
          <div class="header-text-alt">
            <h2 class="card-title-alt">Informações do Cliente</h2>
            <p class="card-subtitle-alt">Dados pessoais e de contato</p>
          </div>
        </div>
        <div class="card-body-alt">
          <div class="grid grid-cols-12 md-grid-cols-1 xs-grid-cols-1 gap-4" formGroupName="customer">
            <mat-form-field subscriptSizing="dynamic" appearance="outline" 
              class="modern-input col-span-4 md-col-span-1"
              [class.loading]="isLoadingDocument">
              <mat-label>CPF / CNPJ</mat-label>
              <input matInput type="text" formControlName="document" [mask]="cpfCnpjMask"
                (change)="validateDocument()" />
            </mat-form-field>

            <mat-form-field subscriptSizing="dynamic" appearance="outline" class="modern-input col-span-8 md-col-span-1">
              <mat-label>Nome</mat-label>
              <input matInput type="text" formControlName="name" maxlength="40" />
            </mat-form-field>

            <mat-form-field subscriptSizing="dynamic" appearance="outline" class="modern-input col-span-8 md-col-span-1">
              <mat-label>E-mail</mat-label>
              <input matInput type="text" formControlName="email" />
            </mat-form-field>

            <mat-form-field subscriptSizing="dynamic" appearance="outline" class="modern-input col-span-4 md-col-span-1">
              <mat-label>Telefone</mat-label>
              <input matInput type="text" formControlName="phone" mask="(00) 00000-0000" />
            </mat-form-field>
          </div>

          <div class="grid grid-cols-12 md-grid-cols-1 xs-grid-cols-1 gap-4 mt-4" formGroupName="address">
            <mat-form-field subscriptSizing="dynamic" appearance="outline" 
              class="modern-input col-span-3 md-col-span-1" 
              [class.loading]="isLoadingZipCode">
              <mat-label>CEP</mat-label>
              <input matInput type="text" formControlName="zipcode" [mask]="'00000-000'" (change)="onZipCodeChange()" />
            </mat-form-field>

            @if(handleZipCode) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="modern-input col-span-3 md-col-span-1">
              <mat-label>Estado</mat-label>
              <mat-select formControlName="state">
                <mat-option *ngFor="let state of states" [value]="state.uf">
                  {{state.uf}} - {{state.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field subscriptSizing="dynamic" appearance="outline" class="modern-input col-span-6 md-col-span-1">
              <mat-label>Cidade</mat-label>
              <input matInput type="text" formControlName="city" />
            </mat-form-field>

            <mat-form-field subscriptSizing="dynamic" appearance="outline" class="modern-input col-span-6 md-col-span-1">
              <mat-label>Bairro</mat-label>
              <input matInput type="text" formControlName="neighborhood" />
            </mat-form-field>

            <mat-form-field subscriptSizing="dynamic" appearance="outline" class="modern-input col-span-6 md-col-span-1">
              <mat-label>Logradouro</mat-label>
              <input matInput type="text" formControlName="street" />
            </mat-form-field>

            <mat-form-field subscriptSizing="dynamic" appearance="outline" class="modern-input col-span-3 md-col-span-1">
              <mat-label>Número</mat-label>
              <input matInput type="text" formControlName="number" mask="0*" />
            </mat-form-field>

            <mat-form-field subscriptSizing="dynamic" appearance="outline" class="modern-input col-span-6 md-col-span-1">
              <mat-label>Complemento</mat-label>
              <input matInput type="text" formControlName="complement" maxlength="30" />
            </mat-form-field>
            }
          </div>
        </div>
      </div>

      <!-- Card Veículo -->
      <div class="ultra-card-alt animate-in" formGroupName="vehicle">
        <div class="card-number">02</div>
        <div class="card-header-alt">
          <div class="header-icon-alt">
            <span class="material-icons">drive_eta</span>
          </div>
          <div class="header-text-alt">
            <h2 class="card-title-alt">Informações do Veículo</h2>
            <p class="card-subtitle-alt">Dados técnicos e características</p>
          </div>
        </div>
        <div class="card-body-alt">
          <div class="grid grid-cols-12 md-grid-cols-1 xs-grid-cols-1 gap-4">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="modern-input col-span-6 md-col-span-1">
              <mat-label>Tipo de Veículo</mat-label>
              <mat-select placeholder="Tipo de Veículo" formControlName="businessUnit"
                (selectionChange)="changeBusinessUnit()">
                @for(businessUnit of businessUnitList; track businessUnit.id){
                <mat-option [value]="businessUnit">
                  {{ businessUnit.description }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="modern-input col-span-6 md-col-span-1">
              <mat-label>Tipo de Estrada</mat-label>
              <mat-select placeholder="Tipo de Estrada" formControlName="road">
                @for (road of roadList; track road.id) {
                <mat-option [value]="road">
                  {{ road.name }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field subscriptSizing="dynamic" appearance="outline" 
              class="modern-input col-span-5 md-col-span-1"
              [class.loading]="isLoadingBrands">
              <mat-label>Marca</mat-label>
              <input type="text" matInput [formControl]="brandCtrl" [matAutocomplete]="auto" />
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onBrandSelected($event.option.value)">
                <mat-option *ngFor="let brand of filteredBrands | async" [value]="brand.name">
                  {{ brand.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field subscriptSizing="dynamic" appearance="outline" class="modern-input col-span-4 md-col-span-1">
              <mat-label>Modelo</mat-label>
              <input matInput type="text" formControlName="model" maxlength="" />
            </mat-form-field>

            <mat-form-field subscriptSizing="dynamic" appearance="outline" class="modern-input col-span-3 md-col-span-1">
              <mat-label>Ano de Fabricação</mat-label>
              <input matInput type="text" mask="0000" formControlName="year" />
            </mat-form-field>

            <mat-form-field subscriptSizing="dynamic" appearance="outline" class="modern-input col-span-5 md-col-span-1">
              <mat-label>Quilometragem Atual do Veículo</mat-label>
              <input matInput type="text" formControlName="km" mask="0*" />
            </mat-form-field>

            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="modern-input col-span-12 md-col-span-1">
              <mat-label>Uso mais Frequente do Veículo</mat-label>
              <mat-select placeholder="Uso mais Frequente do Veículo" formControlName="frequentUse">
                @for (frequency of frequentUseList; track frequency.id) {
                <mat-option [value]="frequency">
                  {{ frequency.description }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Card Reclamação -->
      <div class="ultra-card-alt animate-in" formGroupName="allegation">
        <div class="card-number">03</div>
        <div class="card-header-alt">
          <div class="header-icon-alt">
            <span class="material-icons">report_problem</span>
          </div>
          <div class="header-text-alt">
            <h2 class="card-title-alt">Informações da Reclamação</h2>
            <p class="card-subtitle-alt">Descreva o problema encontrado</p>
          </div>
        </div>
        <div class="card-body-alt">
          <div class="grid grid-cols-1 gap-4">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="modern-input">
              <mat-label>Houve outros danos além do pneu (ex.: veículo, roda, queda, lesão física etc.)?</mat-label>
              <mat-select placeholder="Pneu envolvido em acidente com danos pessoais ou materiais"
                formControlName="pwSpecial">
                <mat-option value="N">Não</mat-option>
                <mat-option value="Y">Sim</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="modern-input">
              <mat-label>Conte mais sobre sua reclamação</mat-label>
              <textarea matInput rows="5" formControlName="description" [maxlength]="maxLength"
                (input)="updateCountdown()"></textarea>
              <mat-hint align="end">{{ remainingCharacters }} caracteres restantes</mat-hint>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Card Pneus -->
      <div class="ultra-card animate-in" *ngIf="showTireSection">
        <div class="card-header-modern">
          <div class="header-icon-wrapper">
            <span class="material-icons header-icon">settings</span>
          </div>
          <div class="header-text">
            <h2 class="card-title-modern">Pneus para Atendimento</h2>
            <p class="card-subtitle-modern">Selecione os pneus que precisam de análise</p>
          </div>
        </div>
        <div class="card-body-modern">
          <div class="flex-grid-card">
            <div *ngFor="let tire of tiresArray.controls; let i = index" [formGroupName]="i" class="card-fade-in"
              [style.animation-delay.ms]="i * 100">
              <div class="tire-card-modern">
                @if(i > 0) {
                <button class="tire-remove-btn" (click)="removeTire(i)" type="button">
                  <span class="material-icons">close</span>
                </button>
                }
                <div class="tire-card-header">
                  <div class="tire-icon-wrapper">
                    <span class="material-icons">tire_repair</span>
                  </div>
                  <div class="tire-info">
                    <h3 class="tire-title">Pneu {{ i + 1 }}</h3>
                    <p class="tire-subtitle">Informações e fotos do pneu</p>
                  </div>
                </div>
                <div class="tire-card-body">
                  <div class="status-list">
                    <div class="status-item" [class.completed]="tire.get('customerAllegation').value && tire.get('hasAnalyse').value"
                      [class.pending]="!(tire.get('customerAllegation').value && tire.get('hasAnalyse').value)">
                      <span class="status-icon material-icons">{{ (tire.get('customerAllegation').value && tire.get('hasAnalyse').value) ? 'check_circle' : 'radio_button_unchecked' }}</span>
                      <span class="status-label">Informações do Dano</span>
                    </div>
                    <div class="status-item" [class.completed]="tire.get('images').get('0')?.value.url"
                      [class.pending]="!tire.get('images').get('0')?.value.url">
                      <span class="status-icon material-icons">{{ tire.get('images').get('0')?.value.url ? 'check_circle' : 'radio_button_unchecked' }}</span>
                      <span class="status-label">Foto DOT</span>
                    </div>
                    <div class="status-item" [class.completed]="tire.get('images').get('1')?.value.url"
                      [class.pending]="!tire.get('images').get('1')?.value.url">
                      <span class="status-icon material-icons">{{ tire.get('images').get('1')?.value.url ? 'check_circle' : 'radio_button_unchecked' }}</span>
                      <span class="status-label">Foto Pneu</span>
                    </div>
                    <div class="status-item" [class.completed]="tire.get('images').get('2')?.value.url"
                      [class.pending]="!tire.get('images').get('2')?.value.url">
                      <span class="status-icon material-icons">{{ tire.get('images').get('2')?.value.url ? 'check_circle' : 'radio_button_unchecked' }}</span>
                      <span class="status-label">Foto Banda de Rodagem</span>
                    </div>
                    <div class="status-item" [class.completed]="tire.get('images').get('3')?.value.url"
                      [class.pending]="!tire.get('images').get('3')?.value.url">
                      <span class="status-icon material-icons">{{ tire.get('images').get('3')?.value.url ? 'check_circle' : 'radio_button_unchecked' }}</span>
                      <span class="status-label">Foto Dano</span>
                    </div>
                    <div class="status-item optional" [class.completed]="tire.get('images').get('4')?.value.url"
                      [class.pending]="!tire.get('images').get('4')?.value.url">
                      <span class="status-icon material-icons">{{ tire.get('images').get('4')?.value.url ? 'check_circle' : 'info' }}</span>
                      <span class="status-label">Foto Adicionais</span>
                      <span class="material-icons optional-info" matTooltipClass="big-tooltip" matTooltip="Fotos adicionais (opcional)">help_outline</span>
                    </div>
                  </div>
                  <button mat-flat-button (click)="openModal(i)" class="tire-open-btn">
                    <span class="material-icons">edit</span>
                    Abrir Detalhes
                  </button>
                </div>
              </div>
            </div>
            @if (pwForm.get('tires').value.length < maxTiresAllowed) {
            <div class="add-tire-card">
              <button class="add-tire-btn" (click)="addTire()" type="button">
                <div class="add-tire-icon">
                  <span class="material-icons">add_circle_outline</span>
                </div>
                <span class="add-tire-text">Adicionar Pneu</span>
                <span class="add-tire-hint">Clique para adicionar mais um pneu</span>
              </button>
            </div>
            }
          </div>
        </div>
      </div>

      <!-- Política de Privacidade -->
      <div class="ultra-card animate-in privacy-section">
        <div class="privacy-checkbox-wrapper">
          <mat-checkbox [(ngModel)]="privacyAccepted" [ngModelOptions]="{standalone: true}" class="privacy-checkbox" (ngModelChange)="onPrivacyChange($event)">
            <span class="privacy-text">
              Li e aceito a 
              <a href="javascript:void(0)" class="privacy-link" (click)="openPrivacyModal($event)">Política de Privacidade de Dados</a>
            </span>
          </mat-checkbox>
        </div>
      </div>

      <!-- Captcha Ultra Moderno -->
      <div class="ultra-card animate-in captcha-ultra-modern" [class.verified]="captchaVerified" [class.minimalist]="captchaMinimalist">
        <div class="captcha-custom-wrapper">
          <div class="captcha-custom-header">
            <div class="captcha-icon-container" [class.verified]="captchaVerified">
              <span class="material-icons captcha-lock-icon">
                {{ captchaVerified ? 'verified_user' : 'shield' }}
              </span>
            </div>
            <div class="captcha-header-text">
              <span class="captcha-custom-title">Verificação de Segurança</span>
              <span class="captcha-subtitle">{{ captchaVerified ? 'Verificado com sucesso' : 'Confirme que você não é um robô' }}</span>
            </div>
            <div class="captcha-status-badge" [class.verified]="captchaVerified">
              <span class="material-icons">{{ captchaVerified ? 'check_circle' : 'pending' }}</span>
            </div>
          </div>
          <div class="captcha-custom-body">
            <div #captchaContainer class="captcha-iframe-wrapper"></div>
            <div class="captcha-verified-overlay" *ngIf="captchaVerified && !captchaMinimalist">
              <div class="success-animation">
                <span class="material-icons success-icon">check_circle</span>
                <div class="success-particles">
                  <span class="particle"></span>
                  <span class="particle"></span>
                  <span class="particle"></span>
                  <span class="particle"></span>
                </div>
              </div>
              <span class="success-text">Verificação Completa!</span>
              <span class="success-subtext">Sua identidade foi confirmada</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Botão de Envio Ultra Moderno -->
      <div class="submit-section animate-in">
        <button mat-flat-button color="primary" class="ultra-submit-btn" (click)="create()" 
          [disabled]="!pwForm.valid || !privacyAccepted || isSubmitting"
          [class.submitting]="isSubmitting">
          <span class="material-icons btn-icon" *ngIf="!isSubmitting">send</span>
          <span class="submit-spinner" *ngIf="isSubmitting"></span>
          <span class="btn-text">{{ isSubmitting ? 'Enviando...' : 'Enviar Reclamação' }}</span>
        </button>
      </div>

    </form>
    }
    
    <!-- Feedback Success -->
    @if(msgFeedback){
    <div class="grid-feedback">
      <div class="grid-feedback_box">
        <span class="material-icons icon-msg-big">email</span>
        <span class="material-icons icon-msg-small">email</span>
      </div>
      <div class="box-msg-feedbak">
        <h1 class="font-michelin-unit-titling-Bold">PAT Criada, nº <strong>{{numberPAT}}</strong></h1>
        <p>Sua solicitação será analisada pelo SAC, a nossa Central de Atendimento, que funciona de segunda a sexta-feira
          das 9 às 16hs. Qualquer dúvida, você pode entrar em contato com a nossa Central pelo 0800 970 9400. Sua
          reclamação será tratada por nossos técnicos e um retorno será dado o mais breve possível.</p>
        <button mat-flat-button color="primary" class="mt-4 btn-large" (click)="newSubmiteFunc()">Solicitar um novo pedido</button>
      </div>
    </div>
    }

  </div>
</div>

<mic-modal #myModal (result)="onModalClosed($event)"></mic-modal>
@if(selectedTireIndex() !== null) {
<ng-template #contentModal let-indexPneu="index">
  <div class="modal-modern-wrapper">
    <!-- Modal Header -->
    <div class="modal-modern-header">
      <div class="modal-header-icon">
        <span class="material-icons">tire_repair</span>
      </div>
      <div class="modal-header-content">
        <h2 class="modal-title">Pneu {{ selectedTireIndex() + 1 }}</h2>
        <p class="modal-subtitle">Complete as informações e fotos do pneu</p>
      </div>
    </div>

    <!-- Reference Image -->
    <div class="modal-reference-image">
      <img src="https://www.michelin-ads.com/assets/michelin/corte-do-pneu-base.jpg" alt="Informações do Pneu">
      <div class="reference-overlay">
        <span class="material-icons">info</span>
        <span>Imagem de referência</span>
      </div>
    </div>

    <!-- Form Content -->
    <div class="modal-form-content" [formGroup]="getTireForm(selectedTireIndex())">
      <!-- Section 1: Informações -->
      <div class="modal-section">
        <div class="section-body">
          <mat-form-field subscriptSizing="dynamic" appearance="outline" class="modern-input">
            <mat-label>Alegação do Cliente</mat-label>
            <mat-select formControlName="customerAllegation" placeholder="Selecione a alegação">
              @for (claim of customerAllegationList; track claim.id) {
              <mat-option [value]="claim">{{ claim.description }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field subscriptSizing="dynamic" appearance="outline" class="modern-input">
            <mat-label>O pneu já foi analisado em alguma revenda Michelin?</mat-label>
            <mat-select placeholder="Selecione uma opção" formControlName="hasAnalyse">
              <mat-option value="N" (click)="hasAnalyse('N')">Não</mat-option>
              <mat-option value="Y" (click)="hasAnalyse('Y')">Sim</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field subscriptSizing="dynamic" appearance="outline" class="modern-input">
            <mat-label>{{ addInfoLabel }}</mat-label>
            <textarea matInput rows="4" formControlName="additionalInformation" placeholder="Descreva informações adicionais..." [maxlength]="maxLengthAdditionalInfoCharacters" (input)="updateAdditionalInfoCountdown()"></textarea>
            <mat-hint align="end">{{ remainingAdditionalInfoCharacters }} caracteres restantes</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <!-- Section 2: Guia de Fotos -->
      <div class="modal-section">
        <div class="section-header">
          <span class="material-icons">photo_library</span>
          <h3>Guia de Fotos Necessárias</h3>
        </div>
        <div class="section-body">
          <p class="guide-text">Para análise técnica do pneu, são necessárias fotos específicas conforme os exemplos abaixo:</p>
          <div class="photo-guide-grid">
            <div class="guide-card">
              <div class="guide-image-wrapper">
                <app-upload-foto [preloadedImage]="'https://www.michelin-ads.com/assets/michelin/DotAuxilio.jpg'"
                  [allowRemove]="false" [name]="'DOT'"></app-upload-foto>
              </div>
              <div class="guide-label">
                <span class="material-icons">check_circle_outline</span>
                <span>DOT</span>
              </div>
            </div>
            <div class="guide-card">
              <div class="guide-image-wrapper">
                <app-upload-foto [preloadedImage]="'https://www.michelin-ads.com/assets/michelin/PneuAuxilio.jpg'"
                  [allowRemove]="false" [name]="'PNEU'"></app-upload-foto>
              </div>
              <div class="guide-label">
                <span class="material-icons">check_circle_outline</span>
                <span>PNEU</span>
              </div>
            </div>
            <div class="guide-card">
              <div class="guide-image-wrapper">
                <app-upload-foto [preloadedImage]="'https://www.michelin-ads.com/assets/michelin/RodagemAuxilio.jpg'"
                  [allowRemove]="false" [name]="'BANDA DE RODAGEM'"></app-upload-foto>
              </div>
              <div class="guide-label">
                <span class="material-icons">check_circle_outline</span>
                <span>BANDA DE RODAGEM</span>
              </div>
            </div>
            <div class="guide-card">
              <div class="guide-image-wrapper">
                <app-upload-foto [preloadedImage]="'https://www.michelin-ads.com/assets/michelin/DanoAuxilioB.jpg'"
                  [allowRemove]="false" [name]="'DANO'"></app-upload-foto>
              </div>
              <div class="guide-label">
                <span class="material-icons">check_circle_outline</span>
                <span>DANO</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 3: Upload de Fotos -->
      <div class="modal-section">
        <div class="section-header">
          <span class="material-icons">cloud_upload</span>
          <h3>Upload de Fotos</h3>
        </div>
        <div class="section-body">
          <div class="upload-grid">
            <div *ngFor="let control of imagesFormArray?.controls; let i = index" class="upload-item">
              <app-upload-foto [image]="control.value.url" [name]="control.value.name"
                (selectedImage)="updateImage(selectedTireIndex(), i, $event)"></app-upload-foto>
            </div>
          </div>
          <button mat-flat-button class="add-photos-btn" (click)="addMorePhotos(selectedTireIndex())">
            <span class="material-icons">add_photo_alternate</span>
            Adicionar mais fotos
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
}

<ng-template #privacyPolicyModal>
  <div class="privacy-modal-content">
    <div class="privacy-modal-icon">
      <span class="material-icons">privacy_tip</span>
    </div>
    <h2 class="privacy-modal-title">Política de Privacidade de Dados</h2>
    <div class="privacy-modal-text">
      <p>O Grupo Michelin está comprometido com a privacidade e com a proteção de seus dados pessoais e, baseado nestes
        princípios, adota as medidas técnicas e administrativas necessárias para proteger as informações que você
        compartilha conosco.</p>
      <p>Os dados pessoais fornecidos, em razão do preenchimento deste formulário, serão tratados por nós e/ou por
        terceiros que nos auxiliam nesse processo, visando atender às finalidades relacionadas ao processo de
        Solicitação de Pedido de Análise Técnica (PAT SAC), bem como ocorrerá em observância à Lei Federal nº 13.709/18 
        (Lei Geral de Proteção de Dados Pessoais - LGPD) e às demais políticas internas do Grupo Michelin sobre o assunto 
        (Política de Privacidade).</p>
      <p>Por questões operacionais internas, caso você opte por não fornecer determinado dado pessoal, o qual foi
        solicitado, importante para atender à estas finalidades, nós não seremos capazes de seguir com o referido processo.</p>
      <p>Caso tenha qualquer dúvida com relação a forma pela qual tratamos seus dados ou queira exercer um de seus
        direitos previstos em lei, por favor, entre em contato conosco.</p>
      <p>Ao aceitar, você declara serem verídicas as informações prestadas no formulário disponibilizado, assumindo toda
        e qualquer responsabilidade pelas mesmas, bem como autoriza a esta empresa a obter, tratar e compartilhar as
        informações fornecidas, necessárias para este processo, de acordo com a Política de Privacidade da empresa.</p>
    </div>
    <div class="privacy-modal-checkbox">
      <mat-checkbox [(ngModel)]="privacyAccepted" [ngModelOptions]="{standalone: true}" id="privacyCheckbox">
        <span class="checkbox-label">Li e aceito os termos de política de privacidade</span>
      </mat-checkbox>
    </div>
  </div>
</ng-template>
